"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _keycode = _interopRequireDefault(require("keycode"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _StyleConfig = require("../utils/StyleConfig");
var _useFocusManager = _interopRequireDefault(require("../utils/useFocusManager"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _Overlay = _interopRequireDefault(require("../Overlay/Overlay"));
var _excluded = ["className", "classNameMap", "cssBlock", "overflowButtonLabel", "overflowButtonProps", "onOverflowToggle", "overflowItemsSize", "children", "popperId"];
/* eslint-disable react/jsx-no-bind */
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ToolbarOverflow = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
    classNameMap = props.classNameMap,
    cssBlock = props.cssBlock,
    overflowButtonLabel = props.overflowButtonLabel,
    overflowButtonProps = props.overflowButtonProps,
    onOverflowToggle = props.onOverflowToggle,
    overflowItemsSize = props.overflowItemsSize,
    children = props.children,
    popperId = props.popperId,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOverlayOpen = _useState2[0],
    setIsOverlayOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isFocusWithin = _useState4[0],
    setIsFocusWithin = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    suppressAttachment = _useState6[0],
    setSuppressAttachment = _useState6[1];
  var overflowTriggerRef = (0, _react.useRef)();
  var overflowRef = (0, _react.useRef)();
  var overflowMenuId = (0, _useUniqueId.default)();
  if (popperId !== null && popperId !== void 0 && (0, _trim.default)(popperId).call(popperId)) {
    overflowMenuId = popperId;
  }
  var classnames = _bind.default.bind(classNameMap);
  (0, _react.useEffect)(function () {
    setSuppressAttachment(isOverlayOpen);
  }, [isOverlayOpen]);
  (0, _useFocusManager.default)({
    nextKeyCode: _keycode.default.codes.down,
    previousKeyCode: _keycode.default.codes.up,
    firstFocusIndex: 0,
    suppressInitialAttachment: suppressAttachment
  }, isOverlayOpen && isFocusWithin, overflowRef);
  var classes = classnames("".concat(cssBlock, "__overflow"), className);
  var toggle = function toggle(value) {
    setIsOverlayOpen(value);
    setIsFocusWithin(value);
    if (typeof onOverflowToggle === 'function') {
      onOverflowToggle(value);
    }
  };
  var isOverflowFlyout = function isOverflowFlyout(eventNode) {
    var _document;
    var flyOuts = (0, _slice.default)(Array.prototype).call((_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll('[data-overflow-flyout="true"]'));
    if (flyOuts !== null && flyOuts !== void 0 && flyOuts.length) {
      return flyOuts.some(function (flyOut) {
        return flyOut === null || flyOut === void 0 ? void 0 : flyOut.contains(eventNode);
      });
    }
    return false;
  };
  var overflowTrigger = /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    "aria-controls": isOverlayOpen ? overflowMenuId : null,
    "aria-expanded": isOverlayOpen,
    "aria-haspopup": true,
    iconName: "kebab"
  }, overflowButtonProps, {
    active: isOverlayOpen,
    ariaLabel: overflowButtonLabel,
    ref: overflowTriggerRef,
    "data-toolbar-trigger": true
  }));
  var addChildProps = function addChildProps(classnamesFn, child, childProps) {
    if (child.displayName === 'ButtonDropdown') {
      return {
        size: overflowItemsSize,
        onToggle: (0, _chainFunction.default)(childProps === null || childProps === void 0 ? void 0 : childProps.onToggle, function (isOpen) {
          setIsFocusWithin(!isOpen);
        }),
        type: 'link',
        buttonClassName: classnamesFn("".concat(cssBlock, "__dropdown-button")),
        containerProps: {
          className: classnamesFn("".concat(cssBlock, "__overflow-item"))
        },
        popperProps: {
          maxWidth: 276,
          widthSizingType: 'none',
          targetClassName: classnamesFn("".concat(cssBlock, "__dropdown-popper")),
          popperProps: {
            'data-overflow-flyout': true
          }
        },
        openClassName: classnamesFn("".concat(cssBlock, "__overflown-dropdown--open")),
        pullRight: false,
        placement: ['right-start', 'left-start', 'bottom-end', 'top-end', 'bottom-start', 'top-start'],
        noCaret: true,
        textLabel: childProps.hideTextLabel ? childProps.textLabel : null,
        title: [childProps.hideTextLabel ? null : childProps.textLabel, ' ', childProps.title, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          key: "0",
          ariaHidden: true,
          forceSize: "xs-plus",
          iconName: "arrow-2-e"
        })]
      };
    }
    if (child.displayName === 'Button') {
      return {
        size: overflowItemsSize,
        type: childProps !== null && childProps !== void 0 && childProps['data-toolbar-group-part'] ? childProps === null || childProps === void 0 ? void 0 : childProps.type : 'link',
        className: classnamesFn(childProps.className, "".concat(cssBlock, "__overflow-item"))
      };
    }
    if (child.displayName === 'MenuButton') {
      return {
        className: classnamesFn("".concat(cssBlock, "__overflow-item")),
        overlayProps: {
          popperPlacement: ['right-start', 'left-start', 'right', 'left', 'auto'],
          targetClassName: classnamesFn("".concat(cssBlock, "__overflow-item"))
        },
        iconProps: {
          iconName: 'arrow-2-e'
        }
      };
    }
    if (child.displayName === 'SplitButton') {
      return {
        type: (childProps === null || childProps === void 0 ? void 0 : childProps.type) || 'link',
        overlayProps: {
          onShow: function onShow() {
            setIsFocusWithin(false);
          },
          onHide: function onHide() {
            setIsFocusWithin(true);
          }
        }
      };
    }
    if (child.displayName === 'ToolbarSeparator') {
      return {
        horizontal: true
      };
    }
    if (child.displayName === 'Tooltip') {
      return {
        targetClassName: classnamesFn("".concat(cssBlock, "__overflow-item")),
        placement: ['right', 'left']
      };
    }
    if (child.displayName === 'Checkbox' || child.displayName === 'Switch') {
      return {
        className: classnamesFn("".concat(cssBlock, "__overflow-field"))
      };
    }
    if (child.displayName === 'Link') {
      var _context;
      return {
        size: overflowItemsSize,
        className: classnamesFn("".concat(cssBlock, "__overflow-item"), "".concat(cssBlock, "__overflow-link"), (0, _concat.default)(_context = "".concat(cssBlock, "__overflow-link--")).call(_context, overflowItemsSize))
      };
    }
    if (child.displayName === 'ToggleSwitch') {
      var _context2;
      return {
        size: overflowItemsSize,
        className: classnamesFn((0, _concat.default)(_context2 = "".concat(cssBlock, "__overflow-item--margin-")).call(_context2, overflowItemsSize))
      };
    }
    if (child.displayName === 'InputField' || child.displayName === 'SelectField') {
      var _context3;
      return {
        size: overflowItemsSize,
        className: classnamesFn("".concat(cssBlock, "__overflow-field"), (0, _concat.default)(_context3 = "".concat(cssBlock, "__overflow-item--margin-")).call(_context3, overflowItemsSize))
      };
    }
    if (child.displayName === 'RadioGroup') {
      var _context4;
      return {
        size: overflowItemsSize,
        className: classnamesFn("".concat(cssBlock, "__overflow-field"), (0, _concat.default)(_context4 = "".concat(cssBlock, "__overflow-item--margin-")).call(_context4, overflowItemsSize))
      };
    }
    return {};
  };
  return /*#__PURE__*/_react.default.createElement(_Overlay.default, {
    targetComponent: overflowTrigger,
    onShow: function onShow() {
      return toggle(true);
    },
    onHide: function onHide() {
      return toggle(false);
    },
    popperPlacement: "bottom-end",
    onKeyDown: function onKeyDown(event) {
      var keyName = (0, _keycode.default)(event);
      if (isOverlayOpen && (keyName === 'left' || keyName === 'right')) {
        event === null || event === void 0 || event.stopPropagation();
      }
    },
    onClickOutside: function onClickOutside(e) {
      return isOverflowFlyout(e === null || e === void 0 ? void 0 : e.target);
    },
    disableFocusManager: true,
    maxWidth: 320
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    id: overflowMenuId,
    className: classes,
    ref: (0, _reactMergeRefs.default)([ref, overflowRef])
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps.bind(null, classnames)
  }, children)));
});
ToolbarOverflow.displayName = 'ToolbarOverflow';
ToolbarOverflow.propTypes = {
  /** @ignore, set by Toolbar. */
  overflowButtonLabel: _propTypes.default.string.isRequired,
  /** @ignore, set by Toolbar. */
  className: _propTypes.default.string,
  /** @ignore, set by Toolbar. */
  cssBlock: _propTypes.default.string,
  /** @ignore, set by Toolbar. */
  overflowButtonProps: _propTypes.default.object,
  /** @ignore, set by Toolbar. */
  overflowItemsSize: _propTypes.default.oneOf(_StyleConfig.CONTROL_SIZES),
  /** @ignore, set by Toolbar. */
  children: _propTypes.default.node,
  /** @ignore, set by Toolbar. */
  popperId: _propTypes.default.string,
  /** @ignore, set by Toolbar. */
  onOverflowToggle: _propTypes.default.func
};
ToolbarOverflow.defaultProps = {
  overflowItemsSize: 'lg'
};
var _default = ToolbarOverflow;
exports.default = _default;